<template>
  <content-box class="change-plan--wrap" :width="'530px'">
    <template v-if="!topUpJam">
      <p class="title">
        {{ $t('common.chargePv') }}
      </p>
      <div class="plan-type--wrap">
        <!-- <div class="plan-type" :class="paymentType">
          <button type="button"
                  class="card"
                  :class="{on: paymentType === 'card'}"
                  :style="{opacity: ($i18n.locale !== 'ko' && paymentType === 'wireTransfer') ? 0.5 : 1}"
                  @click="onSelectPaymentType('card')">
            <i class="icon icon--check-white-size20"></i>{{ $t('userInfo.managePlan.planSubscription.button.card') }}
          </button>
          <button type="button"
                  class="enterprise"
                  :class="{on: paymentType === 'wireTransfer'}"
                  :style="{opacity: ($i18n.locale !== 'ko' && paymentType === 'card') ? 0.5 : 1}"
                  @click="onSelectPaymentType('wireTransfer')">
            <i class="icon icon--check-white-size20"></i>{{ $t('userInfo.managePlan.planSubscription.button.wire') }}
          </button>
        </div> -->
      </div>
      <div class="plan-info--wrap">
        <div class="pv-title">
          {{ $t('userInfo.managePlan.default.wire') }}
        </div>
        <div class="pv-price">
          <p class="label">
            <strong>{{ pvAmount | thousand }}</strong> PV
            <span class="period">
            {{ $t('common.subscriptionTerms') }}: {{ period.start | dashDate }} ~ {{ period.end | dashDate }}
          </span>
          </p>
          <div class="value">
            <p>{{ currencySymbol }} {{ pvPrice | thousand }}</p>
            <span>({{ $t('common.vat') }})</span>
          </div>
        </div>
        <div class="pv-button">
          <ui-button :iconName="'icon--minus-black'"
                     :size="'large'"
                     @click="setChargeAmount(-1)"></ui-button>
          <input class="pv-text"
                 type="'text'"
                 v-model="chargeAmount"
                 @input="setChargeAmount" />
          <ui-button :iconName="'icon--plus-black'"
                     :size="'large'"
                     @click="setChargeAmount(1)"></ui-button>
        </div>
      </div>
      <div class="notice--wrap">
        <ul>
          <li>
            <p>{{ $t('userInfo.managePlan.chargePv.notice.minimumAmount') }}</p>
          </li>
          <li>
            <p>{{ $t('userInfo.managePlan.chargePv.notice.reloadedImmediately') }}</p>
          </li>
          <li v-if="$t('userInfo.managePlan.chargePv.notice.unitPrice')">
            <p>{{ $t('userInfo.managePlan.chargePv.notice.unitPrice') }}</p>
          </li>
          <li>
            <p>{{ $t('userInfo.managePlan.chargePv.notice.notBeCarried') }}</p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <ui-checkbox v-model="isTermsAgree" v-if="paymentType === 'card'">
        <span class="terms-agree">
          {{ $t('userInfo.managePlan.changePlan.footer.checkbox') }}
        </span>
        </ui-checkbox>
        <span class="terms-agree" v-else v-html="$t('userInfo.managePlan.planSubscription.wireDescription')">
      </span>
        <span v-if="hasTermsError" class="terms-agree-validation-text">{{ $t('common.validationErrorText.requiredAgree') }}</span>
        <div class="button--wrap">
          <ui-button class="btn__cancel"
                     @click="onCloseLayer">{{ $t('common.cancel') }}</ui-button>
          <ui-button class="btn__confirm"
                     :primary="true"
                     @click="onConfirm"
                     v-if="paymentType === 'card' && $i18n.locale === 'ko'">
            {{ $t('common.confirm') }}
          </ui-button>
          <ui-button class="btn__confirm"
                     :primary2="true"
                     @click="onConfirm"
                     v-else>
            {{ $t('userInfo.managePlan.planSubscription.button.contact') }}
          </ui-button>
        </div>
      </div>
    </template>
    <template v-else>
      <p class="title">
        {{ $t('common.chargeJam') }}
      </p>
      <div class="plan-info-topup--wrap">
        <template>
          <div class="jam-title">
            {{ $t('userInfo.managePlan.default.wire') }}
          </div>
          <div class="jam-price">
            <div class="label">
              <div style="display: flex; align-items: center;">
                <div class="icon icon--jam--24px"></div>
                <strong>{{ jamChargeAmount | thousand }}</strong>
                <span style="margin-top: 5px;" class="count">{{ $t('plan.jam.jamAmount') }}</span>
              </div>
              <span class="period">
                {{ $t('common.subscriptionTerms') }}: {{ jamPeriod.start | dashDate }} ~ {{ jamPeriod.end | dashDate }}
              </span>
            </div>
            <div class="value">
              <p>{{ currencySymbol }} {{ jamChargePrice | thousand }}</p>
              <span>({{ $t('common.vat') }})</span>
            </div>
          </div>
          <div class="jam-button">
            <ui-button
              :iconName="'icon--minus-black'"
              :size="'large'"
              :disabled="jamChargeAmount === 10"
              @click="setJamChargeAmount(-10)">
            </ui-button>
            <input class="pv-text"
                   type="'text'"
                   :disabled=true
                   v-model="jamChargeAmount"
                   @input="setJamChargeAmount" />
            <ui-button :iconName="'icon--plus-black'"
                       :size="'large'"
                       @click="setJamChargeAmount(10)">
            </ui-button>
          </div>
        </template>
      </div>
      <div  class="notice--wrap">
        <ul>
          <li>
            <p v-html="$t('plan.jam.topUpJam.about')"></p>
          </li>
          <li>
            <p v-html="$t('plan.jam.topUpJam.period')"></p>
          </li>
          <li>
            <p v-html="$t('plan.jam.topUpJam.description')"></p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <div class="footer-description">
          <span class="terms-agree"  v-html="$t('userInfo.managePlan.planSubscription.wireDescription')">
          </span>
        </div>
        <span v-if="hasTermsError" class="terms-agree-validation-text">{{ $t('common.validationErrorText.requiredAgree') }}</span>
        <div class="button--wrap">
          <ui-button class="btn__cancel" @click="onCloseLayer">{{ $t('common.cancel') }}</ui-button>
          <ui-button class="btn__confirm"
                     :primary2="true"
                     @click="onConfirm('jamcharge')"
          >
            {{ $t('userInfo.managePlan.planSubscription.button.contact') }}
          </ui-button>
        </div>
      </div>
    </template>
  </content-box>
</template>

<script>
import { addDays, addMonths } from 'date-fns'
import { openContactUs, getLocaleDateStr, thousand } from '@/libs/utils'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiCheckbox from '@/components/ui/UiCheckbox'

const pvUnit = 100000
const jamUnit = 10000
const pvPrice = 0.1
const jamPrice = 0.0001
const includeVat = 1.1

// 언어별 단가 (VAT 별도) — PV는 1단위(=100,000 PV), JAM은 1개 기준
const pvUnitPriceByLocale = { ko: 150000, en: 300, ja: 22500 }
const jamUnitPriceByLocale = { ko: 1000, en: 1, ja: 100 }
const currencySymbolByLocale = { ko: '₩', en: '$', ja: '¥' }

export default {
  components: {
    ContentBox,
    UiButton,
    UiCheckbox
  },
  props: [
    'userData',
    'planData',
    'newPlanData',
    'topUpJam',
    'remainJam'
  ],
  data () {
    return {
      hasTermsError: false,
      isTermsAgree: false,
      paymentType: 'wireTransfer',
      chargeAmount: 1,
      jamChargeAmount: 10,
      jamUseAmount: 10,
      period: {
        start: null,
        end: null
      },
      jamPeriod: {
        start: null,
        end: null
      },
      TopUpProcess: false
    }
  },
  computed: {
    pvAmount () {
      return 100000 * this.chargeAmount
    },
    currencySymbol () {
      return currencySymbolByLocale[this.$i18n.locale] || currencySymbolByLocale.ko
    },
    pvPrice () {
      const unitPrice = pvUnitPriceByLocale[this.$i18n.locale] || pvUnitPriceByLocale.ko
      return unitPrice * this.chargeAmount
    },
    jamAmount () {
      return jamUnit * this.jamUseAmount
    },
    jamPrice () {
      return jamPrice * this.jamAmount
    },
    jamChargePrice () {
      const unitPrice = jamUnitPriceByLocale[this.$i18n.locale] || jamUnitPriceByLocale.ko
      return unitPrice * this.jamChargeAmount
    },
    planInfoSelector () {
      if (this.paymentType !== 'jam') {
        return 'notJam'
      } else {
        if (this.remainJam) {
          return 'jamRemain'
        } else {
          return 'noJam'
        }
      }
    },
    expireDateFormat () {
      return getLocaleDateStr(addDays(this.planData.endDate, 1))
    }
  },
  created () {
    const fiveYearsAfter = addMonths(new Date(), 60)
    this.period.start = this.planData && this.planData.monthlyStartDate
    this.jamPeriod.start = new Date()
    this.jamPeriod.end = addDays(fiveYearsAfter, -1)
    if (this.$i18n.locale !== 'ko') {
      this.paymentType = 'wireTransfer'
    }
    if (this.topUpJam) this.paymentType = 'wireTransfer'
    this.period.end = this.planData && this.planData.monthlyEndDate
  },
  methods: {
    setChargeAmount (value) {
      if (value) {
        this.chargeAmount = this.chargeAmount + value
      }
      this.chargeAmount = parseInt(this.chargeAmount) || 1
      if (this.chargeAmount > 10000000) {
        this.chargeAmount = 10000000
      } else if (this.chargeAmount < 1) {
        this.chargeAmount = 1
      }
    },
    setJamChargeAmount (value) {
      if (value) {
        this.jamChargeAmount = this.jamChargeAmount + value
      }
      this.jamChargeAmount = parseInt(this.jamChargeAmount) || 1
      if (this.jamChargeAmount > 10000000) {
        this.jamChargeAmount = 10000000
      } else if (this.jamChargeAmount < 10) {
        this.jamChargeAmount = 10
      }
    },
    onSelectPaymentType (value) {
      if (this.$i18n.locale === 'ko') {
        this.hasTermsError = false
        this.paymentType = value
      }
    },
    canChargePv () {
      if (this.planData.isTerminated || this.planData.isTrial ||
        this.planData.isTrialOver || this.planData.isUnpaid ||
        !this.planData.hasPlan || this.planData.useCoupon ||
        this.$i18n.locale === 'ja') {
        return false
      } else {
        return true
      }
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    },
    onOpenTopUpJamLayer () {
      this.$emit('onTopUpJam', true)
      if (this.$i18n.locale === 'ko') {
        this.paymentType = 'wireTransfer'
      } else {
        this.paymentType = 'wireTransfer'
      }
    },
    onConfirm (type) {
      this.hasTermsError = false

      const isJam = type === 'jamcharge'
      const baseAmount = isJam ? this.jamChargeAmount : this.chargeAmount
      const basePrice = isJam ? this.jamChargePrice : this.pvPrice

      if (!this.isTermsAgree) {
        this.hasTermsError = true
      }

      const formKey = isJam ? 'plan.jam.jamForm' : 'userInfo.managePlan.default.wireForm'

      const messageParams = {
        product: this.$t(isJam ? 'common.chargeJam' : 'common.HeatmapChargePV'),
        amount: thousand(baseAmount),
        price: thousand(basePrice)
      }

      if (!isJam) {
        messageParams.pv = thousand(this.pvAmount)
      }

      openContactUs(
        this.userData,
        this.$t(formKey, messageParams),
        true
      )

      this.onCloseLayer()
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.change-plan--wrap {
  padding: 30px 30px 25px;
  box-sizing: border-box;

  .plan-type--wrap {
    margin-top: 24px;
    text-align: center;

    .plan-type {
      display: inline-block;
      width: 430px;
      border: 1px solid #e0e0e0;
      background-color: #ffffff;
      transition: background-color 0.3s ease, border-color 0.3s ease;
      border-radius: 20px;
      position: relative;

      button {
        width: 210px;
        text-align: center;
        line-height: 36px;
        height: 36px;
        color: #888888;
        position: relative;
        font-size: 15px;
        z-index: 2;
        transition: color 0.3s ease;

        &:first-child {
          box-sizing: border-box;
          padding-right: 5px;
        }

        &:last-child {
          box-sizing: border-box;
          padding-right: 5px;
        }

        i {
          vertical-align: middle;
          transform: translateY(-1px);
          width: 0;
          transition: width 0.3s ease, margin 0.3s ease;
        }

        &.on {
          color: #ffffff;

          i {
            width: 20px;
            margin: 0 20px 0 0;
          }
        }
      }

      &::before {
        content: "";
        position: absolute;
        z-index: 1;
        top: -1px;
        left: -1px;
        background: #ec0147;
        border-radius: 20px;
        transition: left 0.3s cubic-bezier(0.25, 1, 0.5, 1);
        display: block;
        width: 220px;
        height: 38px;
        box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.25);
      }

      &.jam::before {
        left: 247px;
      }

      &.wireTransfer::before {
        left: 211px;
      }
    }
  }

  .plan-type-topup--wrap {
    margin-top: 24px;
    text-align: center;

    .plan-type {
      display: inline-block;
      width: 470px;
      border: 1px solid #e0e0e0;
      background-color: #ffffff;
      transition: background-color 0.3s ease, border-color 0.3s ease;
      border-radius: 20px;
      position: relative;

      button {
        width: 210px;
        text-align: center;
        line-height: 36px;
        height: 36px;
        color: #888888;
        position: relative;
        font-size: 15px;
        z-index: 2;
        transition: color 0.3s ease;
        position: relative;

        &:first-child {
          box-sizing: border-box;
          padding-right: 5px;
        }

        &:last-child {
          box-sizing: border-box;
          padding-right: 5px;
        }

        i {
          position: absolute;
          bottom: 8px;
          left: 10px;
          vertical-align: middle;
          transform: translateY(-1px);
          width: 0;
          transition: width 0.3s ease, margin 0.3s ease;
        }

        &.on {
          color: #ffffff;

          i {
            width: 20px;
            margin: 0 20px 0 0;
          }
        }
      }

      &::before {
        content: "";
        position: absolute;
        z-index: 1;
        top: -1px;
        left: -1px;
        background: #ec0147;
        border-radius: 20px;
        transition: left 0.3s cubic-bezier(.28,.12,.42,.94);
        display: block;
        width: 235px;
        height: 38px;
        box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.25);
      }

      &.wireTransfer::before {
        left: 235px;
      }
    }
  }

  .title {
    font-size: 15px;
    font-weight: 500;
    color: #2f2f2f;
  }

  .plan-info--wrap {
    margin-top: 33px;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    .pv-title {
      font-size: 13px;
      color: #444;
      font-weight: 500;
      margin-bottom: 13px;
    }
    .pv-price {
      @include flexXbetween;
      align-items: center;

      .label {
        font-size: 16px;
        color: #ec0047;

        strong {
          font-size: 28px;
          font-weight: 600;
        }

        .period {
          font-size: 13px;
          color: #666666;
          display: block;
          margin-top: 10px;
          font-weight: 500;
        }
      }

      .value {
        text-align: right;
        p {
          font-size: 16px;
          font-weight: 600;
          color: #2f2f2f;
        }
        span {
          display: inline-block;
          font-size: 12px;
          color: #444444;
          margin-top: 8px;
          font-weight: 500;
        }
      }
    }

    .pv-button {
      border-top: 2px solid #c1c1c1;
      margin-top: 30px;
      padding-top: 25px;
      text-align: center;

      .pv-text {
        -webkit-appearance: none;
        width: 70px;
        height: 38px;
        border-radius: 6px;
        border: 1px solid #289eef;
        background-color: #ffffff;
        vertical-align: middle;
        text-align: center;
        font-size: 16px;
        color: #2f2f2f;
        margin: 0 5px;
      }

      button {
        min-width: 0;
        padding-right: 2px;
        vertical-align: middle;
      }
    }

    .jam-button {
      border-top: 2px solid #c1c1c1;
      margin-top: 30px;
      padding-top: 25px;
      display: flex;
      align-items: center;
      position: relative;

      .jam-text {
        -webkit-appearance: none;
        width: 70px;
        height: 38px;
        border-radius: 6px;
        border: 1px solid #289eef;
        background-color: #ffffff;
        vertical-align: middle;
        text-align: center;
        font-size: 16px;
        color: #2f2f2f;
        margin: 0 5px;
      }

      button {
        min-width: 0;
        padding-right: 2px;
        vertical-align: middle;
      }

      .remainjam {
        font-size: 16px;
        color: #2f2f2f;
      }

      .icon--jam--24px {
        width: 20px;
        height: 20px;
        margin: 0px 7px;
      }

      .btn__jam {
        position: absolute;
        min-width: 85px;
        padding: 0 15px;
        right: 0;
      }
    }

    .icon--no-jam {
      margin: 15px 0;
      width: 165px;
      height: 130px;
    }
  }

  .plan-info-topup--wrap {
    margin-top: 33px;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    .jam-title {
      font-size: 13px;
      color: #444;
      font-weight: 500;
      margin-bottom: 13px;
    }
    .jam-price {
      @include flexXbetween;
      align-items: center;

      .label {
        font-size: 16px;
        color: #ec0047;

        strong {
          margin-left: 10px;
          font-size: 28px;
          font-weight: 500;
        }

        .count {
          margin-left: 10px;
        }

        .period {
          font-size: 13px;
          color: #666666;
          display: block;
          margin-top: 10px;
        }

        .icon--small-jam {
          width: 24px;
          height: 24px;
        }
      }

      .value {
        text-align: right;
        p {
          font-size: 16px;
          font-weight: 500;
          color: #2f2f2f;
        }
        span {
          display: inline-block;
          font-size: 12px;
          color: #444444;
          margin-top: 8px;
        }
      }
    }

    .jam-button {
      border-top: 2px solid #c1c1c1;
      margin-top: 30px;
      padding-top: 25px;
      text-align: center;

      .pv-text {
        -webkit-appearance: none;
        width: 70px;
        height: 38px;
        border-radius: 6px;
        border: 1px solid #289eef;
        background-color: #ffffff;
        vertical-align: middle;
        text-align: center;
        font-size: 16px;
        color: #2f2f2f;
        margin: 0 5px;
      }

      button {
        min-width: 0;
        padding-right: 2px;
        vertical-align: middle;
      }
    }
  }

  .notice--wrap {
    margin-top: 25px;

    ul > li {
      position: relative;
      padding-left: 20px;
      font-size: 13px;
      line-height: 1.46;
      color: #666666;
      font-weight: 500;

      &:before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 3px;
        background-color: #888;
        position: absolute;
        top: 7px;
        left: 10px;
      }

      &:not(:first-child) {
        margin-top: 10px;
      }

      ol {
        margin-top: 10px;

        li {
          @include flexXbetween;

          &:not(:first-child) {
            margin-top: 5px;
          }

          button {
            font-size: 12px;
            font-weight: 600;
            text-align: right;
            color: #555555;
          }
        }
      }
    }
  }

  .nojam {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer {
    margin-top: 25px;
    padding-top: 25px;
    border-top: 1px solid #d8d8d8;
    text-align: center;
    position: relative;

    .button--wrap {
      margin-top: 40px;

      button {
        min-width: 86px;
      }

      .btn__confirm {
        margin-left: 5px;
      }
    }

    .ui_checkbox {
      margin-left: 0;
    }
    .terms-agree {
      position: relative;
      text-align: left;
      font-size: 13px;
      color: #2f2f2f;
      font-weight: 500;
    }
    .terms-agree-validation-text {
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 13px;
      color: $brandColor;
      white-space: nowrap;
      display: inline-block;
    }
  }
}
</style>
